function Header(props){
    return(
       <header>
            <div className="mhead">
                <h1 className="head">{props.title}</h1>
                <nav>
                    <ul className="navigation">
                        {props.links.map((link, index) => (
                            <li key={index}>{link}</li>
                        ))}
                    </ul>
                </nav>  
            </div>
       </header>
    );
}

export default Header;